import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  isLoading = signal(false);

  constructor() {}

  public startLoading(): void {
    this.isLoading.set(true);
  }

  public stopLoading(): void {
    this.isLoading.set(false);
  }
}
